import * as HttpStatus from 'http-status-codes';

export class StatusCodeService {

    static GetMessage = (httpStatus: number, method: string): string => {
        let message: string = HttpStatus.getStatusText(httpStatus);

        switch (httpStatus) {
            //400
            case HttpStatus.BAD_REQUEST:
                switch (method) {
                    // Add custom message per service calls
                }
                break;
            //403
            case HttpStatus.FORBIDDEN:
                switch (method) {
                    // Add custom message per service calls
                }
                break;

            //404
            case HttpStatus.NOT_FOUND:
                switch (method) {
                    // Add custom message per service calls
                }
                break;

            //422
            case HttpStatus.UNPROCESSABLE_ENTITY:
                switch (method) {
                    // Add custom message per service calls
                }
                break;

            //423
            case HttpStatus.LOCKED:
                switch (method) {
                    // Add custom message per service calls
                }
                break;

            //500
            case HttpStatus.INTERNAL_SERVER_ERROR:
                switch (method) {
                    // Add custom message per service calls
                }
                break;
        }

        return message;
    }
}